import { endPoints, requestType } from "../constants/variables";
import Api, { apiForm } from "./index";

const createSession = (payload) => {
  return Api(endPoints.createFaceLivenessSession, payload, requestType.POST);
};

// const createSession = (payload, token) => {
//   return Api(
//     endPoints.createFaceLivenessSession,
//     payload,
//     requestType.POST,
//     token
//   );
// };

const startVerification = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/start`,
    null,
    requestType.POST
  );
};

const verifyProcess = (sessionId, payload) => {
  return Api(
    `${endPoints.verifyFace}/${sessionId}`,
    payload,
    requestType.POST
  );
};

const trackPageVisiting = (sessionId) => {
  return Api(
    `${endPoints.trackPageVisiting}/${sessionId}/track`,
    null,
    requestType.POST
  );
};

const markAsScanned = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/scan`,
    null,
    requestType.POST
  );
};

const getConfig = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/config`,
    null,
    requestType.GET
  );
};

const getSessionStatus = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/status`,
    null,
    requestType.GET
  );
};

const cancelVerification = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/cancel`,
    null,
    requestType.POST
  );
};

const reportFailure = (sessionId, payload) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/report-failure`,
    payload,
    requestType.POST
  );
};

/**
 * Uploads the captured document straight to the IDV service.
 *
 * The absolute URL and the short-lived bearer token both come from Certage's
 * getConfig response: document bytes never pass through Certage Backend.
 */
const uploadDocuments = (uploadUrl, uploadToken, formData) => {
  return apiForm(uploadUrl, formData, uploadToken);
};
export { createSession, startVerification, verifyProcess, trackPageVisiting, markAsScanned, getConfig, getSessionStatus, cancelVerification, reportFailure, uploadDocuments };
